"use client";
import { withAuth } from "@/app/components/providers/withAuth";
import { ChatComplete } from "./c/[id]/component";

function HomePage() {
   return (
      <main className="h-screen bg-gray-50 dark:bg-gray-900 relative">
         <ChatComplete />
      </main>
   );
}
export default withAuth(HomePage);
